import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = environment.useOfflineMode ? './assets/fonts/nunito/nunito.css' : 'https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap';
document.head.appendChild(fontLink);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

RecaptchaComponent.prototype.ngOnDestroy = function() {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}